import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import screen from 'superior-mq';
import { bp, hoverSpoofer } from 'Styles/helpers';
import objectPath from 'object-path';
import InlineLink from '../inline-link';
import Section from '../section';
import HomeH3 from '../home/HomeH3';
import Container from '../container';
import TextWave from '../text-wave';
import ProjectName from '../project-name/ProjectName';
import Grid from '../grid';
import RenderMd from '../render-md';
import LazyImg from '../lazy-img';
import StaggerIn from '../stagger-in';

const titleGridStyles = css`
  ${screen.below(bp.tablet, `
    grid-column: 1 / span 12;
    margin-bottom: 20px;
  `)}

  ${screen.below(bp.mobile, `
    max-width: 305px;
    margin-bottom: 40px;
  `)}
`;

const contentGridStyles = css`
  grid-column: 8 / span 4;

  ${screen.below(bp.desktop, `
    grid-column: 8 / span 5;
  `)}

  ${screen.below(bp.tablet, `
    grid-column: 1 / span 6;
  `)}

  ${screen.below(bp.mobile, `
    grid-column: 1 / span 12;
  `)}
`;

const fundraiserGridStyles = css`
  position: relative;
  margin-top: 150px;

  ${screen.below(bp.desktop, `
    margin-top: 76px;
  `)}

  ${hoverSpoofer(Grid.Item)}
`;

const fundraiserGridItemStyles = css`
  ${screen.below(bp.portrait, `
    grid-column: span 6;

    &:last-of-type {
      margin-top: 35px;
    }
  `)}

  ${screen.below(bp.mobileSm, `
    grid-column: span 12;

    &:not(:first-of-type) {
      margin-top: 35px;
    }

    img {
      width: 100%;
    }
  `)}
`;

export default class Content3Up extends PureComponent {

  static propTypes = {
    title: PropTypes.string,
    intro: PropTypes.string,
    contentBlocks: PropTypes.arrayOf(PropTypes.object),
    portraitImg: PropTypes.bool,
    home: PropTypes.bool,
  }

  static defaultProps = {
    contentBlocks: [],
  }

  render() {
    if (this.props.contentBlocks.length < 1) return null;

    return (
      <Section dark>
        <Container>

          <Grid>
            <Grid.Item span={5} styles={titleGridStyles}>
              <TextWave>

                {this.props.home
                  ? <H2>{this.props.title}</H2>
                  : <HomeH3 align="left">{this.props.title}</HomeH3>
                }

              </TextWave>
            </Grid.Item>

            <Grid.Item styles={contentGridStyles}>
              <Content>
                <RenderMd source={this.props.intro} />
              </Content>
            </Grid.Item>

          </Grid>

          <StaggerIn>
            <Grid styles={fundraiserGridStyles}>

              {this.props.contentBlocks.map(block => (
                <Grid.Item className="js-stagger" span={4} styles={fundraiserGridItemStyles} key={block.sys.id}>
                  <InlineLink
                    href={block.fields.blockLink}
                    style={{ textDecoration: 'none', display: 'block', paddingBottom: '16px', height: '100%' }}
                  >
                    <figure>

                      {this.props.portraitImg && objectPath.has(block, 'fields.photo.fields.file.url') &&
                        <LazyImg
                          key={block.fields.photo.sys.id}
                          width={466}
                          height={570}
                          src={`${block.fields.photo.fields.file.url}?w=466&h=570&fit=thumb&q=80&fm=jpg&fl=progressive`}
                          alt={block.fields.photo.fields.description}
                          picture={[
                            {
                              srcSet: `${block.fields.photo.fields.file.url}?w=608&h=450&fit=thumb&q=80&fm=jpg&fl=progressive`,
                              media: '(max-width: 580px)',
                              width: 608,
                              height: 450,
                            },
                          ]}
                        />
                      }

                      {!this.props.portraitImg && objectPath.has(block, 'fields.photo.fields.file.url') &&
                        <LazyImg
                          key={block.fields.photo.sys.id}
                          width={466}
                          height={310}
                          src={`${block.fields.photo.fields.file.url}?w=466&h=310&fit=thumb&q=80&fm=jpg&fl=progressive`}
                          alt={block.fields.photo.fields.description}
                        />
                      }

                      <FigCap>
                        <ProjectName color="blue">
                          {block.fields.title}
                        </ProjectName>
                        <ProjectBlurb>
                          {block.fields.description}
                        </ProjectBlurb>
                      </FigCap>

                    </figure>
                  </InlineLink>
                </Grid.Item>
              ))}

            </Grid>
          </StaggerIn>

        </Container>
      </Section>
    );
  }
}

const Content = styled.div`
  p {
    margin: 0;
    max-width: 440px;
  }
`;

const H2 = styled.h2`
  text-align: left;
`;

const FigCap = styled.figcaption`
  margin-top: 44px;

  ${screen.below(bp.mobile, `
    margin-top: 18px;
  `)}
`;

const ProjectBlurb = styled.p`
  margin-top: 5px;
  color: #fff;

  ${screen.below(bp.mobile, `
    margin-top: 10px;
  `)}
`;
